


































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import DateComponent from "@/components/common/Inputs/Date.vue";
import { AppConstants as _app } from "@/shared/app.constants";
import DocumentForm from "@/components/common/Inputs/Documents.vue";
// import Workspace from "./FinancialReport/Workspace.vue";
import { MigrationImport } from "@/entities";

const namespace: string = "migration";

@Component({
  components: {
    DateComponent,
    DocumentForm,
    Workspace: () => import("./FinancialReport/Workspace.vue"),
    DialogComponent: () =>
      import("@/components/common/Dialog/DialogComponent.vue"),
  },
})
export default class FinancialReportingPeriod extends Vue {
  @State(namespace) migration!: MigrationImport;

  @Prop() grantSchema: any;
  @Prop() readOnly: boolean;
  @Prop() grantId: number;
  @Prop() modelWrapper: any;
  @Prop() tags: any;
  @Prop() subKey: any;
  @Prop() isDirty!: boolean;
  @Action("showNotification", { namespace: "application" }) notify: any;
  actions = _app.actions;
  subjects = _app.subjects;
  finPeriodKey: number = 1;
  selectedFrequency: number = _app.reportingPeriods.technical;
  showDocs: boolean = false;
  showEdit: boolean = false;
  docActions = [{ event: "close", text: "Close" }];
  editActions = [
    { event: "save", text: "Save" },
    { event: "close", text: "Close" },
  ];
  selectedIndex: number = -1;
  periodStatus = [
    { dispalyText: "Open", value: 1 },
    { dispalyText: "Closed", value: 0 },
  ];

  // reporting frequency dropdown options
  reportingFrequency: any = [
    { dispalyText: "Quarter", abbr: "Q", value: 3 },
    { dispalyText: "Half year", abbr: "H", value: 6 },
    { dispalyText: "Year", abbr: "Y", value: 12 },
  ];
  dialog = false;
  grantIsOpen: number = _app.migrationGrantStatus.open;
  selectedKey: string= "";

  mounted() {
    this.getSubKey();
    this.addEmptyRow();
  }

  getReportinPeriods() {
    this.modelWrapper.grant.financialReportingPeriods =
      this.$services.agreement.getReportingPeriods(
        this.modelWrapper.projectStartDate,
        this.modelWrapper.projectEndDate,
        this.selectedFrequency || _app.reportingPeriods.financial
      );
    this.$emit("input", true);
    this.addEmptyRow();
  }

  getSubKey() {
    if (this.grantSchema && this.grantSchema.properties) {
      delete this.grantSchema.properties.finDocs;
      delete this.grantSchema.properties.summary;

      this.selectedKey = Object.keys(this.grantSchema.properties)[0];
    }
  }

  Add() {
    this.modelWrapper.grant.financialReportingPeriods.push({});
  }

  finPeriods() {
    if (this.modelWrapper.grant.financialReportingPeriods) {
      return this.modelWrapper.grant.financialReportingPeriods;
    } else {
      this.modelWrapper.grant.financialReportingPeriods = [{}];
      return this.modelWrapper.grant.financialReportingPeriods;
    }
  }

  addEmptyRow() {
    if (this.modelWrapper.grant.financialReportingPeriods) {
      const emptyRow = this.modelWrapper.grant.financialReportingPeriods.find(
        (x) => Object.keys(x).length === 0
      );
      if (!emptyRow) {
        this.modelWrapper.grant.financialReportingPeriods.push({});
        this.finPeriodKey += 1;
      }
    }
    // this.finPeriodKey += 1;
  }

  EmptyRow() {
    this.$emit("input", true);
    this.addEmptyRow();
  }

  finReport(index) {
    this.selectedIndex = index;
    //this.dialog = true;
    this.showDocs = true;
  }

  get docTags(): any {
    var self = this;
    return this.tags
      .filter((x) => x.Section === this.subKey)
      .map(({ Id, Name }) => ({
        Id: Id,
        Name: Name,
      }));
  }

  /** event period changed */
  periodChanged(doc, val, index) {
    var periods = this.$services.agreement.updatePeriod(
      this.modelWrapper.grant.financialReportingPeriods,
      doc,
      index,
      this.modelWrapper,
      _app.reportingPeriods.financial,
      this.modelWrapper.projectStartDate,
      this.modelWrapper.projectEndDate
    );
    this.modelWrapper.grant.financialReportingPeriods = periods;
    this.addEmptyRow();
    this.finPeriodKey += 1;
  }

  /** validate the start date */
  validateStartDate(doc, val, index) {
    const msg = this.$services.agreement.validateStartDate(
      this.modelWrapper.grant.financialReportingPeriods,
      doc,
      index,
      val,
      this.modelWrapper,
      this.modelWrapper.projectStartDate,
      this.modelWrapper.projectEndDate
    );
    if (msg) {
      this.notify({
        text: msg,
        isHtml: true,
        color: "error",
      });
    } else {
      doc.startDate = val;
      this.addEmptyRow();
      this.finPeriodKey += 1;
    }
  }

  /** validate the end date */
  validateEndDate(doc, val, index) {
    const msg = this.$services.agreement.validateEndDate(
      this.modelWrapper,
      doc,
      index,
      val,
      "financialReportingPeriods",
      _app.reportingPeriods.financial,
      this.modelWrapper.projectStartDate,
      this.modelWrapper.projectEndDate
    );

    if (msg) {
      this.notify({
        text: msg,
        isHtml: true,
        color: "error",
      });
    } else {
      doc.endDate = val;
      this.addEmptyRow();
      this.finPeriodKey += 1;
    }
  }

  /** validate the due date */
  validateDueDate(doc, val, index) {
    const msg = this.$services.agreement.validateDueDate(
      this.modelWrapper.grant.financialReportingPeriods,
      doc,
      index,
      val,
      this.modelWrapper,
      this.modelWrapper.projectStartDate,
      this.modelWrapper.projectEndDate
    );

    if (msg) {
      this.notify({
        text: msg,
        isHtml: true,
        color: "error",
      });
    } else {
      doc.dueDate = val;
      this.addEmptyRow();
      this.finPeriodKey += 1;
    }
  }

  onRemoveRow(index, doc) {
    this.modelWrapper.grant.financialReportingPeriods.splice(index, 1);
    // this.$emit('fileChange', doc);
    this.addEmptyRow();
    this.finPeriodKey += 1;
    this.$emit("input");
  }

  get buttonVisibility() {
    //@ts-ignore
    if (this.$can(this.actions.manage, this.subjects.grantAgree)) {
      // secratariat users with just review only roles have only read permission
      return true;
    }
  }

  edit(index) {
    this.selectedIndex = index;
    this.showEdit = true;
  }

  subMenuChanged(key) {
    this.selectedKey = key;
    this.$emit("subMenuChanged", key);
  }
}
